export default __webpack_public_path__ + "static/media/veronika_l.25d5bb6e.jpg";